module.exports = __webpack_public_path__ + "media/1_18.3bd2b891.wav";